module.exports = "https://web-assets.ifttt.com/packs/media/docs/actionsfeedly-3c07c5a9.gif";